import React from 'react';
import { getLocalFile } from './util/fileUtil';
import Papa from 'papaparse';
import { Control } from './sample/control';
import { ErcotDiagram } from './sample/ercot/ercotDiagram';
import { NWDiagram } from './sample/nw/nwDiagram';

import './App.scss';


/** Main component of our application. */
class App extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            diagramName: 'ERCOT',
            layers: [], // Each layer is { number, label }
            activeLayers: new Set([]), // This is of the form [ numbers ]
            label: undefined,
            description: undefined
        };
    }
  
    /** Parses the content from layers.csv to set up layer information. */
    parseLayerData = (csv) => {
        // Parse the content: results.data is an array of arrays of cell values
        let results = Papa.parse(csv);
        
        const layers = [];

        // For each row of the CSV
        for (const cellArray of results.data) {
            const layerNum = parseInt(cellArray[0]);
            if (!isNaN(layerNum)) {
                // Numeric, so this row contains a mapping
                const layerColor = cellArray[1].trim();
                const layerLabel = cellArray[3].trim();
                const layer = {
                    number: layerNum,
                    color: layerColor,
                    label: layerLabel
                };
                layers.push(layer);
            }
        }

        this.setState({ layers });
    };

    componentDidMount() {
        // Read the layers information
        getLocalFile('layers.csv')
            .then(this.parseLayerData);
    }

    /** Sets a layer active/inactive. */
    setLayer = (layer, isChecked) => {
        let activeLayers = this.state.activeLayers;
        if (isChecked) {
            activeLayers.add(layer);
        }
        else {
            activeLayers.delete(layer);
        }

        this.setState({ activeLayers });
    }

    /** Sets the description to use. */
    setDescription = (label, description) => {
        this.setState({ label, description });
    };

    /** Gets a component by name string. */
    getDiagramComponent = (name) => {
        name = name || 'ERCOT';
        name = name.toLowerCase();

        const lookup = {
            ercot: ErcotDiagram,
            nw: NWDiagram
        }
        return lookup[name];
    }

    /** Sets the diagram to display. */
    setDiagramName = (diagramName) => {
        if (diagramName !== this.state.diagramName) {
            this.setState({ 
                diagramName, 
                activeLayers: new Set([]),
                label: undefined, 
                description: undefined
            });
        }
    }

    render() {
        // Set the title and component to use
        document.title = this.state.diagramName + ' Diagram';
        const DiagramComponent = this.getDiagramComponent(this.state.diagramName);

        return (
            <div className="app">
                <Control
                    layers={this.state.layers}
                    activeLayers={this.state.activeLayers}
                    label={this.state.label}
                    description={this.state.description}
                    setLayer={this.setLayer}
                    diagramName={this.state.diagramName}
                    setDiagramName={this.setDiagramName}
                />
                <div className="graphics">
                    <DiagramComponent
                        connectionsFile={this.state.diagramName + 'connections.json'}
                        layers={this.state.layers}
                        activeLayers={this.state.activeLayers}
                        setDescription={this.setDescription}
                    />
                    <div className="logo-header">
                        <a id="pnnlLogo" href="https://www.pnnl.gov/">
                            Pacific Northwest National Laboratory
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}

export default App;
